<template>
  <MsLoading fullscreen waves size="lg" label="Starting metastory">
    <MsLogo variant="mark" />
  </MsLoading>
</template>
<script lang="ts">

import {WorkspaceNs} from '@shared/types'
import {defineComponent} from 'vue'
import {cookies, getBaseDomain, getStoredToken} from "@shared/helpers";
import {HTTPErrorEnums, redirectToSignIn} from "@shared/http-client";
import {mapStores} from "pinia";
import {useUserStore} from "@shared/stores/user.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {COOKIE_NAMES} from "@shared/constants/common.constants";
import {MsLoading, MsLogo, toast} from '@shared/ms-components'

export default defineComponent({
  name: 'AppLoadingWidget',
  components: {MsLoading, MsLogo},
  computed: {
    ...mapStores(useWorkspaceStore, useUserStore, useGeneralStore)
  },
  mounted(): void {
    getStoredToken()
    this.userStore.getUserMe().then(() => {
      this.userStore.loadUiPreferences().then(() => {
      })
      this.workspaceStore.loadUserWorkspaceList().then((workspaceList) => this.selectWorkspace(workspaceList))
    })
    .catch((error) => {
      if (error?.status?.toString() === HTTPErrorEnums.HTTP400) {
        redirectToSignIn()
      } else {
        setTimeout(() => {
          this.userStore.loadUiPreferences().then(() => {
          })
          this.workspaceStore.loadUserWorkspaceList().then((workspaceList) => this.selectWorkspace(workspaceList))
        }, 2000)
      }
    })
  },

  methods: {
    selectWorkspace(workspaceList: WorkspaceNs.Workspace[]) {
      const workspaceStr = cookies.get('meta-workspace')
      if (!workspaceStr) {
        redirectToSignIn()
      }
      const wsInfo = JSON.parse(workspaceStr!) as WorkspaceNs.SelectedWorkspaceInfo
      if (!wsInfo) {
        redirectToSignIn()
      }

      const selectedWorkspace = workspaceList.find((workspace: WorkspaceNs.Workspace) => workspace.id === wsInfo.id)
      if (!selectedWorkspace) {
        toast.error('Access to this workspace is restricted. Contact the workspace admin');
        redirectToSignIn()
        return
      }

      this.workspaceStore.switchToWorkspace(selectedWorkspace)

      const afterSignInRedirect = JSON.parse(cookies.get(COOKIE_NAMES.AFTER_SIGN_IN) || "{}" as any);

      const redirectPath = this.$route.query.redirectTo;
      const processQueryParams = (queryObj: any) => {
        const queryParam: Record<string, any> = {};
        Object.entries(queryObj).forEach(([key, value]) => {
          if (key !== 'redirectTo') {
            queryParam[key] = value;
          }
        });
        return queryParam;
      };

      if (afterSignInRedirect && afterSignInRedirect.search) {
        cookies.remove(COOKIE_NAMES.AFTER_SIGN_IN, {domain: getBaseDomain});
        const query = afterSignInRedirect.search
        .substring(1)
        .split('&')
        .reduce((acc: Record<string, string>, pair: string) => {
          const [key, value] = pair.split('=');
          acc[key] = value;
          return acc;
        }, {});

        this.$router.push({
          path: String(afterSignInRedirect.name),
          query: processQueryParams(query)
        });
      } else if (redirectPath) {
        this.$router.push({
          path: String(redirectPath),
          query: processQueryParams(this.$route.query)
        });
      } else {
        this.$router.push('/dashboard');
      }
    }
  }
})

</script>
